import { useState, useEffect, useRef, useContext } from 'react';
import { useSelector } from 'react-redux';
import PageContext from '../sub-components/PageContext';
import HeaderBanner from '../sub-components/HeaderBanner.tsx';
import OrderedDataTable from '../sub-components/OrderedDataTableCopy.jsx';
import PageDropdown from '../sub-components/PageDropdownCopy.jsx';
import PageTabs from '../sub-components/PageTabsCopy.jsx'; 
import { HttpContext } from '../../api-services/HttpService';
import standardFilter from '../functions/standardFilter';
import applyFilters from '../functions/applyFilters';
import SnackbarAlert from '../sub-components/SnackbarAlert';
import formatDate from '../functions/formatDate'; 
import getPageTabs from '../functions/getPageTabs';
import { Box, styled, Typography } from '@mui/material';
import PageBreadcrumbs from '../sub-components/PageBreadcrumbs.jsx'; 
import InfoLabel from '../sub-components/InfoLabel.jsx';
import WorkflowButton from '../sub-components/WorkflowButton.jsx';
import RebateSummaryIndicator from '../sub-components/RebateSummaryIndicator.jsx';
import StandardRowFormatted from '../sub-components/StandardRowFormatted.jsx'; 
import PayoutInfoRow from '../sub-components/PayoutInfoRow.jsx';
import AdhocDataRow from '../sub-components/AdhocDataRow.jsx';
import ButtonComponent from '../sub-components/ButtonComponent.jsx';
import UploadContractRow from '../sub-components/UploadContractRow.jsx'; 
import BonusAggregateRow from '../sub-components/BonusAggregateRow.jsx'; 
import RebateBreakupRow from '../sub-components/RebateBreakupRow.jsx';
import BannerAlert from '../sub-components/BannerAlert'; 
import WorkflowModal from '../sub-components/WorkflowModal';
import OverrideModal from '../sub-components/OverrideModal.jsx'; 
import AddAdhocPaymentModal from '../sub-components/AddAdhocPaymentModal.jsx';
import MarkPaymentFailedModal from '../sub-components/MarkPaymentFailedModal.jsx'; 
import EditAdhocPaymentModal from '../sub-components/EditAdhocPaymentModal.jsx'; 
import { useNavigate } from 'react-router-dom';
import isNullUndefinedEmpty from '../functions/isNullUndefinedEmpty.js'; 
import isNullOrUndefined from '../functions/isNullOrUndefined.js'; 
import ViewClawbacksModal from '../sub-components/ViewClawbacksModal.jsx';
import ContractUploadCommentModal from '../sub-components/ContractUploadCommentModal.jsx'; 

// Styled Topography for table name
const TableName = styled(Typography)(({ theme }) => ({
    // background: "#E6F6FA",
    // color: "#3D3D3D",
    background: process.env.REACT_APP_LABEL_COLOR,
    color: `${process.env.REACT_APP_LABEL_TEXT_COLOR} !important`,
    justifyContent: "center",
    fontSize: "14px",
    minHeight: "40px",
    lineHeight: "24px",
    display: "flex",
    alignItems: "center",
    fontFamily:"Roboto medium, Helvetica, Arial, sans-serif"
}));

const CompanyBonusViewPage = () => {
    // initialize http context 
    const {
        GET,  
    } = useContext(HttpContext);
    // intialize default page tabs 
    const pageTabs = [
        {tag: 'Current Cycle', key: 0, active: true}, 
        {tag: 'Bonus Setups', key: 1, active: true}, 
        {tag: 'Payout Info', key: 2, active: true}, 
        {tag: 'Payment History', key: 3, active: true}, 
        {tag: 'Client Contracts', key: 4, active: process.env.REACT_APP_UPLOAD_CLIENT_CONTRACTS == '1'}
    ]; 
    // global redux state for company (passed in from other route)
    const company = useSelector((state) => state.company);
    const companyInfo = useSelector((state) => state.companyInfo);
    // initailize state for period id dropdowns
    const [periodId, setPeriodId] = useState('');
    const [periodList, setPeriodList] = useState(['']);
    // initialize state for workflow modal 
    const [workflowModal, setWorkflowModal] = useState(false);
    const [workflowAction, setWorkflowAction] = useState('');
    const [workflowNewStatus, setWorkflowNewStatus] = useState('');
    const [workflowActionId, setWorkflowActionId] = useState(''); 
    const [workflowAggregateDataList, setWorkflowAggregateDataList] = useState([]); 
    const [workflowAggregateTableHeader, setWorkflowAggregateTableHeader] = useState([]); 
    // initialize reference for workflow modal
    const workflowButtonCss = useRef('modal-button-full-blue');
    const workflowOptOut = useRef(false);
    const workflowReviewAction = useRef(false);
    // initialize state for page tabs 
    const [tabValue, setTabValue] = useState(0);
    const [tabList, setTabList] = useState([]);
    // initialize spinner while data is loading
    const [showSpinner, setShowSpinner] = useState(false);
    // initialize state to trigger filter
    const [triggerFilter, setTriggerFilter] = useState(false);
    // initialize state for snackbar 
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [snackbarColor, setSnackbarColor] = useState('info');
    // state for filter resetting 
    const [enableReset, setEnableReset] = useState(false);
    const [isMenuLoaded, setIsMenuLoaded] = useState(false);
    // state for tabs
    const [payoutInfoDataList, setPayoutInfoDataList] = useState([]); 
    const [payoutInfoTableHeader, setPayoutInfoTableHeader] = useState([]); 
    const [adhocDataList, setAdhocDataList] = useState([]); 
    const [adhocTableHeader, setAdhocTableHeader] = useState([]); 
    const [bonusSetupDataList, setBonusSetupDataList] = useState([]); 
    const [bonusSetupTableHeader, setBonusSetupTableHeader] = useState([]); 
    const [overrideType, setOverrideType] = useState([]); 
    const [overrideTypeList, setOverrideTypeList] = useState([]); 
    const [userEntitlementId, setUserEntitlementId] = useState(''); 
    const [status, setStatus] = useState(companyInfo['status']); 
    const [adhocEditBool, setAdhocEditBool] = useState(false); 
    const [enableReopen, setEnableReopen] = useState(false); 
    const [rebateInputTypeId, setRebateInputTypeId] = useState(0); 
    const [uploadContractsDataList, setUploadContractsDataList] = useState([]); 
    const [uploadContractsTableHeader, setUploadContractsTableHeader] = useState([]); 
    const [showClientInfoUpdateAlert, setShowClientInfoUpdateAlert] = useState(false); 
    const [pageRefresh, setPageRefresh] = useState(false); 
    const [aggregateDataList, setAggregateDataList] = useState([]); 
    const [showAggregateDataList, setShowAggregateDataList] = useState([]); 
    const [aggregateTableHeader, setAggregateTableHeader] = useState([]); 
    const [breakupDataList, setBreakupDataList] = useState([]); 
    const [breakupTableHeader, setBreakupTableHeader] = useState([]); 
    const [showOverride, setShowOverride] = useState(true); 
    const [disableWorkflowButton, setDisableWorkflowButton] = useState(false); 
    const [showAddAdhocModal, setShowAddAdhocModal] = useState(false); 
    const [bonusType, setBonusType] = useState('Bonus'); 
    const [subCompanyList, setSubCompanyList] = useState([]); 
    const [masterCompanyId, setMasterCompanyId] = useState(''); 
    const [showMarkPaymentFailedModal, setShowMarkPaymentFailedModal] = useState(false); 
    const [markPaymentFailedRow, setMarkPaymentFailedRow] = useState({}); 
    const [editAdhocRow, setEditAdhocRow] = useState({}); 
    const [adhocInputConfig, setAdhocInputConfig] = useState([]); 
    const [showEditAdhocModal, setShowEditAdhocModal] = useState(false); 
    const [viewClawbackModal, setViewClawbackModal] = useState(false);  
    const [clawbackDataList, setClawbackDataList] = useState([]); 
    const [clawbackTableHeader, setClawbackTableHeader] = useState([]); 
    const [clawbackLists, setClawbackLists] = useState({}); 
    const [clawbackConfig, setClawbackConfig] = useState([]); 
    const [masterCompanyData, setMasterCompanyData] = useState({}); 
    const [viewClawbackIncentiveSetupId, setViewClawbackIncentiveSetupId] = useState(''); 
    const [viewClawbackCompanyId, setViewClawbackCompanyId] = useState(''); 
    const [showContractCommentModal, setShowContractCommentModal] = useState(false); 
    const [contractUploadRow, setContractUploadRow] = useState({}); 
    // state for override modal
    const [editRow, setEditRow] = useState({}); 
    const [overrideModal, setOverrideModal] = useState(false); 
    // use refs to determine initial render
    const initialRender1 = useRef(true); 
    // hook for navigation
    const navigate = useNavigate();

    // event hanlder for clawback magnify
    const onClawbackViewClick = (row) => {
        setViewClawbackModal(viewClawbackModal => viewClawbackModal = true); 
        setViewClawbackIncentiveSetupId(viewClawbackIncentiveSetupId => viewClawbackIncentiveSetupId = row['incentivesetupid']); 
        setViewClawbackCompanyId(viewClawbackCompanyId => viewClawbackCompanyId = row['companyid']); 
    }

    // function wrappers to pass row components to datatables
    const BonusRowComponent = (row, count, tableHeader, stickyEnabled) => {
        return <StandardRowFormatted row={row} count={count} tableHeader={tableHeader} onEditClick={()=>{return}} onMagnifyClick={onClawbackViewClick} enableEdit={false} stickyEnabled={stickyEnabled}/>;
    }
    const PayoutInfoRowComponent = (row, count, tableHeader,stickyEnabled) => {
        return <PayoutInfoRow row={row} count={count} tableHeader={tableHeader} enableEdit={false} stickyEnabled={stickyEnabled}/>;
    }
    const PaymentHistoryRowComponent = (row, count, tableHeader,stickyEnabled) =>{
        return <AdhocDataRow row={row} count={count} tableHeader={tableHeader} editBool={adhocEditBool} stickyEnabled={stickyEnabled}/>;
    } 
    const UploadContractRowComponent = (row, count, tableHeader,stickyEnabled) => {
        return <UploadContractRow row={row} count={count} tableHeader={tableHeader} enableEdit={false} stickyEnabled={stickyEnabled}/>;
    }
    const AggregateRowComponent = (row, count, tableHeader, stickyEnabled) => {
        return <BonusAggregateRow row={row} count={count} tableHeader={tableHeader} showOverride={showOverride} stickyEnabled={stickyEnabled}/>
    }
    const BreakupRowComponent = (row, count, tableHeader,stickyEnabled) =>{
        return <RebateBreakupRow row={row} count={count} tableHeader={tableHeader} stickyEnabled={stickyEnabled}/>; 
    } 


    // function to set snackbar state
    const snackbarAlert = (show, message, color) => {
        setSnackbarMessage(snackbarMessage => snackbarMessage = message);
        setSnackbarColor(snackbarColor => snackbarColor = color);
        setShowSnackbar(showSnackbar => showSnackbar = show);
    }

     //reset functionality 
     const resetToDefault = () => {
        setPeriodId(periodList[0]);
    }

    const enableResetAll = () => {
        if(periodId !== periodList[0]
        ){
            return true;
        }
        return false;
    }

    useEffect(() => {
        if(isMenuLoaded && enableResetAll()){
            setEnableReset(true);
        } else {
            setEnableReset(false);
        }
    }, [periodId, isMenuLoaded]); 

    // get bonus data from database
    const getBonusViewData = () => {
        // show spinner while getting data
        setShowSpinner(showSpinner => showSpinner = true);
        return new Promise((resolve, reject) => {
            GET('/aggregates/companyBonusViewPage', {
                mastercompanyid: companyInfo['mastercompanyid'], 
                workflowid: companyInfo['workflowid']
            }).then(res => {
                // set state for rebate aggregate
                setAggregateDataList(aggregateDataList => aggregateDataList = res['data']['BonusViewData']);
                setShowAggregateDataList(showAggregateDataList => showAggregateDataList = res['data']['BonusViewData']); 
                setAggregateTableHeader(aggregateTableHeader => aggregateTableHeader = res['data']['BonusViewCols']);
                // set state for monthly breakup
                setBreakupDataList(breakupDataList => breakupDataList = res['data']['MonthlyBreakupData']);
                setBreakupTableHeader(breakupTableHeader => breakupTableHeader = res['data']['MonthlyBreakupCols']);
                // set state for payout info table 
                setPayoutInfoDataList(payoutInfoDataList => payoutInfoDataList = res['data']['PayoutInfoData']);
                setPayoutInfoTableHeader(payoutInfoTableHeader => payoutInfoTableHeader = res['data']['PayoutInfoCols']);
                // set state for adhoc table 
                setAdhocDataList(adhocDataList => adhocDataList = res['data']['AdhocTableData']); 
                setAdhocTableHeader(adhocTableHeader => adhocTableHeader = res['data']['AdhocTableCols']); 
                // set state for rebate setup table
                setBonusSetupDataList(bonusSetupDataList => bonusSetupDataList = res['data']['BonusSetupsData']);
                setBonusSetupTableHeader(bonusSetupTableHeader => bonusSetupTableHeader = res['data']['BonusSetupsCols']);
                // set period dropdown state
                setPeriodId(periodId => periodId = res['data']['PeriodIdList'][0]);
                setPeriodList(periodList => periodList = res['data']['PeriodIdList']);
                // set override type list 
                setOverrideType(overrideType => overrideType = res['data']['OverrideTypeList'][0]);
                setOverrideTypeList(overrideTypeList => overrideTypeList = res['data']['OverrideTypeList']);
                // set user entitlement id 
                setUserEntitlementId(userEntitlementId => userEntitlementId = res['data']['UserEntitlementId']);
                // set state for status
                setStatus(status => status = res['data']['WorkflowStatus']);
                // set entitlement bool for adhoc data table add/edit 
                setAdhocEditBool(adhocEditBool => adhocEditBool = res['data']['AdhocEntitlement']); 
                // set state for enable reopen 
                setEnableReopen(enableReopen => enableReopen = res['data']['AllowReopen']); 
                // set state for rebate rate input type id
                setRebateInputTypeId(rebateInputTypeId => rebateInputTypeId = res['data']['RebateInputTypeId']); 
                // set state for upload contract table 
                setUploadContractsDataList(uploadContractsDataList => uploadContractsDataList = res['data']['UploadContractsData']); 
                setUploadContractsTableHeader(uploadContractsTableHeader => uploadContractsTableHeader = res['data']['UploadContractsCols']); 
                // set state for client info update alert banner 
                setShowClientInfoUpdateAlert(showClientInfoUpdateAlert => showClientInfoUpdateAlert = res['data']['ClientInfoUpdateAlert']); 
                // set bonus type 
                setBonusType(bonusType => bonusType = res['data']['BonusType']['incentivetype']); 
                // set state for workflow modal 
                setWorkflowAggregateDataList(workflowAggregateDataList => workflowAggregateDataList = res['data']['WorkflowAggregateData']); 
                setWorkflowAggregateTableHeader(workflowAggregateTableHeader => workflowAggregateTableHeader = res['data']['WorkflowAggregateCols']); 
                // set state for adhoc modal
                setSubCompanyList(subCompanyList => subCompanyList = res['data']['SubCompanyList']); 
                setAdhocInputConfig(adhocInputConfig => adhocInputConfig = res['data']['AdhocInputConfig']); 
                // set state for clawbacks modal 
                setClawbackDataList(clawbackDataList => clawbackDataList = res['data']['BonusClawbacksData']); 
                setClawbackTableHeader(clawbackTableHeader => clawbackTableHeader = res['data']['BonusClawbacksCols']); 
                // trigger filter
                setTriggerFilter(triggerFilter => triggerFilter = !triggerFilter);
                // change page refresh to alert useEffects
                setPageRefresh(pageRefresh => pageRefresh = !pageRefresh); 
                // make show spinner false 
                setShowSpinner(showSpinner => showSpinner = false);
                setIsMenuLoaded(true);
                // resolve on success
                resolve(res); 
            }).catch(err => {
                // make show spinner false 
                setShowSpinner(showSpinner => showSpinner = false);
                // reject on error
                reject(err); 
            }); 
        }); 
    }

    // wrapper for workflow modal component
    const fullRefresh = () => {
        return new Promise((resolve, reject) => {
            getBonusViewData().then(res => {
                console.log(res); 
            }).catch(err => {
                console.log(err); 
            }); 
        }); 
    }

    // useEffect to run on initial render
    useEffect(() => {
        // re-route if no companyInfo
        if (isNullUndefinedEmpty(companyInfo)) {
            navigate('/RebateSummaryPage'); 
        }
        else {
            // re-route depending on workflowtypeid
            if (process.env.REACT_APP_REBATE_WORKFLOW_TYPE_ID === companyInfo['workflowtypeid']) {
                navigate('/CompanyPayoutViewPage'); 
            }
            // set masterCompanyId for Adhoc modals 
            setMasterCompanyId(masterCompanyId => masterCompanyId = companyInfo['mastercompanyid']); 
            // set tabs 
            setTabList(tabList => tabList = getPageTabs(pageTabs));
            // get data to display
            getBonusViewData().then(res => {
                console.log(res); 
            }).catch(err => {
                console.log(err);
            }); 
        }
    }, [companyInfo]); 

    // useEffect to determine show override based on period
    useEffect(() => {
        // disable override when period is not last in cycle and user is a submitter
        if (userEntitlementId == process.env.REACT_APP_SUBMITTER_ROLE_ID 
        && !isNullUndefinedEmpty(companyInfo) && !isNullOrUndefined(companyInfo['cycleend'])
        && periodId == companyInfo['cycleend'].slice(0, 4) + '' + companyInfo['cycleend'].slice(5, 7)){
            setShowOverride(showOverride => showOverride = true);
        }
        else{
            setShowOverride(showOverride => showOverride = false);
        }
    }, [periodId, userEntitlementId, pageRefresh]);

    // useEffect to determine where to disable workflow button based on period 
    useEffect(() => {
        // disable workflow action when period is not last in the cycle
        if (!isNullUndefinedEmpty(companyInfo) && !isNullOrUndefined(companyInfo['cycleend'])
        && periodId == companyInfo['cycleend'].slice(0, 4) + '' + companyInfo['cycleend'].slice(5, 7)){
            setDisableWorkflowButton(disableWorkflowButton => disableWorkflowButton = false); 
        }
        else {
            setDisableWorkflowButton(disableWorkflowButton => disableWorkflowButton = true);
        }
    }, [periodId, userEntitlementId, pageRefresh]); 

    // useEffect for sorting rebate cycle aggregate table 
    useEffect(() => {
        if (!initialRender1.current){
            // declare list of functions with parameters to filter/search list
            const functionList = [
                {function: standardFilter, value: periodId, flag: 1, cols: ['periodid']}
            ];
            // use applyFilters function to search by running all functions declared above
            let filteredList = applyFilters(aggregateDataList, functionList);
            // update showDataList
            setShowAggregateDataList(showAggregateDataList => showAggregateDataList = filteredList);
            
        }
        else {
            initialRender1.current = false;
        }
    }, [periodId, triggerFilter]);

    // state to pass to children via context
    const settings = {
        showAddAdhocModal, 
        setShowAddAdhocModal, 
        editRow, 
        setEditRow, 
        overrideModal, 
        setOverrideModal,
        status,
        rebateInputTypeId, 
        workflowModal,  
        setWorkflowModal, 
        workflowAction, 
        setWorkflowAction,
        workflowNewStatus, 
        setWorkflowNewStatus, 
        workflowButtonCss,  
        workflowOptOut, // flag to allow toggle to opt out of rebate workflow
        workflowReviewAction, // flag to determine whether to show dropdown
        userEntitlementId, 
        status, 
        enableReopen, // flag to enable button for reopen action 
        workflowActionId, 
        setWorkflowActionId,
        workflowAggregateTableHeader, 
        workflowAggregateDataList, 
        snackbarAlert, 
        showSnackbar, 
        setShowSnackbar,
        snackbarMessage, 
        snackbarColor, 
        fullRefresh, 
        aggregateTableHeader, 
        overrideTypeList,
        overrideType, 
        setOverrideType, 
        subCompanyList, 
        masterCompanyId, 
        showMarkPaymentFailedModal, 
        setShowMarkPaymentFailedModal, 
        setMarkPaymentFailedRow, 
        markPaymentFailedRow, 
        editAdhocRow, 
        setEditAdhocRow, 
        showEditAdhocModal,
        setShowEditAdhocModal, 
        adhocTableHeader, 
        adhocInputConfig, 
        showContractCommentModal, 
        setShowContractCommentModal, 
        contractUploadRow, 
        setContractUploadRow
    }

    //  show status color
    const showStatus = (value) => {
        // set color based on value
        let color = '#4472C4'; 
        let textColor = 'white'
        if (value == 'Pending'){
            color = '#FFC700'; 
            textColor = 'black'; 
        }
        else if (value == 'Rejected'){
            color = '#EB0000'; 
            textColor = 'white'; 
        }
        else if (value == 'Initial Review'){
            color = '#7E79DD'; 
            textColor = 'white'; 
        }
        else if (value == 'Final Review'){
            color = '#00A6CA'
            textColor = 'white'; 
        }
        else if (value == 'Accepted'){
            color = '#008A00';
            textColor = 'white'; 
        }
        // show text with color
        return (
            <div className="d-flex justify-content-start align-items-center gap-1">
              <Box
                sx={{
                  minWidth: 12,
                  height: 12,
                  bgcolor: color,
                  borderRadius: 100,
                }}
              />
              <div>{value}</div>
            </div>
          );
    }
    // return the render
    return(
        <div class='summary-page'>
            {/* wrap children so they have access to variables in PageContext */}
            <PageContext.Provider value={ settings }>
                {/* header banner and navslider present on every page */}
                <HeaderBanner />
                {/* breadcrumbs */}
                <div className="pt-1 ms-3">
                    <PageBreadcrumbs />
                </div>
                {/* snackbar component for alerts */}
                <SnackbarAlert />
                {/* modal components */}
                <WorkflowModal/> 
                <OverrideModal/> 
                <AddAdhocPaymentModal refreshFunction={fullRefresh}/>
                <EditAdhocPaymentModal refreshFunction={fullRefresh}/>
                <MarkPaymentFailedModal refreshFunction={fullRefresh}/>
                <ViewClawbacksModal 
                    viewClawbackModal={viewClawbackModal} 
                    setViewClawbackModal={setViewClawbackModal} 
                    clawbackTableHeader={clawbackTableHeader} 
                    clawbackDataList={clawbackDataList} 
                    clawbackConfig={clawbackConfig} 
                    clawbackLists={clawbackLists} 
                    showSpinner={showSpinner} 
                    editButtonBool={false} 
                    snackbarAlert={snackbarAlert}
                    getRefreshData={fullRefresh}
                    masterCompanyData={masterCompanyData}
                    incentiveSetupId={viewClawbackIncentiveSetupId}
                    companyId={viewClawbackCompanyId}
                    description={'retention_clawback'}
                />
                <ContractUploadCommentModal />
                {/* top label */}
                <div className="container-fluid d-flex flex-column">
                    <div className="d-flex flex-column flex-grow-1 p-2">
                        <div className="mb-1" style={{ borderRadius: "12px", background: "white" }}>
                            <div className="d-flex p-3 flex-wrap gap-3">
                                <div className="pe-3">
                                    <InfoLabel title={process.env.REACT_APP_MASTER_COMPANY_NAME_TAG + ': '} content={company}/>
                                </div>
                                <div class="vr me-3"></div>
                                <div className="pe-3">
                                    <InfoLabel title={'Bonus Cycle: '} content={formatDate(companyInfo['cyclestart']) + ' to ' + formatDate(companyInfo['cycleend']) }/>
                                </div>   
                                <div class="vr me-3"></div> 
                                <div className="pe-3">
                                    <InfoLabel title={'Porfolio: '} content={companyInfo['incentivetype']}/>
                                </div>   
                                <div class="vr me-3"></div> 
                                <div className="pe-3">
                                    <InfoLabel title={'Company Type: '} content={companyInfo['companytypedescription']}/>
                                </div>  
                            </div>
                        </div>
                        { process.env.REACT_APP_SHOW_CLIENT_INFO_UPDATE_ALERTS == '1' ? 
                            <>
                                <BannerAlert
                                    show={showClientInfoUpdateAlert}
                                    setShow={setShowClientInfoUpdateAlert}
                                    type="warning"
                                    message={
                                        <Typography sx={{ fontSize: "14px", lineHeight: "24px" }}>
                                        <b>Client info has been updated.</b> Allow process to run
                                        overnight to see aggregation with changes.
                                        </Typography>
                                    }
                                />                            
                            </>
                        :<></>}
                        <div className="flex-grow-1 mt-1">
                            <div style={{ background: "white" ,borderRadius: "12px"}} >
                                <div className="d-flex align-items-center justify-content-between" style={{flexWrap:'wrap'}}> 
                                    <div className="d-flex p-2 ps-3 pe-3 align-items-center" style={{flexWrap:'wrap'}}>
                                        <div className="pe-3">
                                            <PageDropdown tag='Period: ' value={periodId} setValue={setPeriodId} list={periodList} width={"6rem"}/>
                                        </div>
                                        <div className="pe-3 align-self-center text-decoration-underline" style={{ color: `${enableReset ? '#0295BE' : '#BDBDBD'}`, cursor: 'pointer', fontFamily: 'Roboto medium' }} onClick={() => enableReset ? resetToDefault() : null}>
                                            Reset All
                                        </div>
                                    </div>
                                    <div className="d-flex p-2 ps-3 pe-3 align-items-center">
                                        <div className="pe-3">
                                            <RebateSummaryIndicator  show={companyInfo['indicator']} ids={companyInfo['indicatorid']} tooltip={companyInfo['tooltip']} />
                                        </div>  
                                        <div className="pe-2">
                                            <InfoLabel title={"Payout Status: "} content={showStatus(status)} />
                                        </div>     
                                        <div>
                                            {/* workflow button component that changes dynamically based on status and user entitlement */}
                                            <WorkflowButton disable={disableWorkflowButton} />
                                        </div> 
                                    </div>         
                                </div>  
                                {/* tabs component for navigation between sections without leaving page */}
                                <div>
                                    <PageTabs value={tabValue} setValue={setTabValue} tabList={tabList}/>
                                </div>
                                 <div className="p-3">
                                    {/* logic to show different sections based on the tab that has been chosen */}
                                    {/* current cycle tab */}
                                    { tabValue === 0 ?
                                    <div style={{ maxHeight: "calc(100vh - 390px)", overflow: "overlay" }}>
                                         <div>
                                            <TableName>{bonusType} Cycle Aggregate</TableName>
                                            <OrderedDataTable disableMaxTableHeight={true} sortingEnabled={true} RowComponent={AggregateRowComponent} dataList={showAggregateDataList} tableHeader={aggregateTableHeader} showSpinner={showSpinner} numToPage={25} skeletonHeight='7vh' stickyFirstColumnEnabled={true}/>
                                        </div>
                                        <br />
                                        <div>
                                            <TableName>Monthly Breakup</TableName>
                                            <OrderedDataTable disableMaxTableHeight={true} sortingEnabled={true} RowComponent={BreakupRowComponent} dataList={breakupDataList} tableHeader={breakupTableHeader} showSpinner={showSpinner} numToPage={25} skeletonHeight='28vh' stickyFirstColumnEnabled={true}/>
                                        </div>
                                    </div>    
                                    /* bonus setups tab */
                                    : tabValue === 1 ?
                                    <div>
                                        <TableName>{bonusType} Setup</TableName>
                                        <OrderedDataTable varHeight={'605px'} sortingEnabled={true} RowComponent={BonusRowComponent} dataList={bonusSetupDataList} tableHeader={bonusSetupTableHeader} showSpinner={showSpinner} numToPage={25} skeletonHeight='28vh' stickyFirstColumnEnabled={true}/>
                                    </div>
                                    /* payout info tab */ 
                                    : tabValue === 2 ? 
                                    <div>
                                        <TableName>Payout Info</TableName>
                                        <OrderedDataTable varHeight={'605px'} sortingEnabled={true} RowComponent={PayoutInfoRowComponent} dataList={payoutInfoDataList} tableHeader={payoutInfoTableHeader} showSpinner={showSpinner} numToPage={25} skeletonHeight='28vh' stickyFirstColumnEnabled={true}/>
                                    </div>
                                    /* payment history tab */
                                    : tabValue === 3 ? 
                                    <div> 
                                        {adhocEditBool && <div className="d-flex mb-2 align-items-center justify-content-end">
                                            <ButtonComponent tag='Add Adhoc-Payment' onButtonClick={()=>setShowAddAdhocModal(showAddAdhocModal => showAddAdhocModal = true)}  border={'#3D3D3D 1px solid'} background={'#fff'} color={'#001317'} width='max-content'/>
                                        </div>}
                                        {adhocEditBool && <hr style={{ marginTop: 0 }} />}
                                        <div>
                                            <TableName>Payment History</TableName>
                                            <OrderedDataTable varHeight={"435px"} sortingEnabled={true} RowComponent={PaymentHistoryRowComponent} dataList={adhocDataList} tableHeader={adhocTableHeader} showSpinner={showSpinner} numToPage={25} skeletonHeight='28vh' stickyFirstColumnEnabled={true}/> 
                                        </div>
                                    </div>
                                    /* upload contracts tab */
                                    : tabValue === 4 ? 
                                    <div>
                                        <TableName>Upload Client Contracts</TableName>
                                        <OrderedDataTable varHeight='440px' sortingEnabled={true} RowComponent={UploadContractRowComponent} tableHeader={uploadContractsTableHeader} dataList={uploadContractsDataList} showSpinner={showSpinner} numToPage={25} skeletonHeight='28vh' stickyFirstColumnEnabled={true}/>
                                    </div>
                                    :<></> }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </PageContext.Provider>
        </div>
    ); 
}

export default CompanyBonusViewPage; 